// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as ProfessionalTermsRouteImport } from './routes/professional-terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PostJobRouteImport } from './routes/post-job'
import { Route as LondonRouteImport } from './routes/london'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CancellationRouteImport } from './routes/cancellation'
import { Route as BrowseRouteImport } from './routes/browse'
import { Route as BecomeHelperRouteImport } from './routes/become-helper'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as HelpersHelperIdRouteImport } from './routes/helpers.$helperId'
import { Route as LondonAreaRouteImport } from './routes/london.$area'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as LondonAreaServiceRouteImport } from './routes/london.$area.$service'
import { Route as AuthenticatedHelperVerificationRouteImport } from './routes/_authenticated/helper.verification'
import { Route as AuthenticatedHelperOnboardRouteImport } from './routes/_authenticated/helper.onboard'
import { Route as AuthenticatedHelperOffersRouteImport } from './routes/_authenticated/helper.offers'
import { Route as AuthenticatedHelperKycRouteImport } from './routes/_authenticated/helper.kyc'
import { Route as AuthenticatedHelperAvailabilityRouteImport } from './routes/_authenticated/helper.availability'
import { Route as AuthenticatedBookingsIdRouteImport } from './routes/_authenticated/bookings.$id'
import { Route as AuthenticatedAdminTrustRouteImport } from './routes/_authenticated/admin.trust'
import { Route as AuthenticatedAdminTawkRouteImport } from './routes/_authenticated/admin.tawk'
import { Route as AuthenticatedAdminStripeTestsRouteImport } from './routes/_authenticated/admin.stripe-tests'
import { Route as AuthenticatedAdminShareDebugRouteImport } from './routes/_authenticated/admin.share-debug'
import { Route as AuthenticatedAdminSecurityRouteImport } from './routes/_authenticated/admin.security'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin.reviews'
import { Route as AuthenticatedAdminQualityRouteImport } from './routes/_authenticated/admin.quality'
import { Route as AuthenticatedAdminOpsRouteImport } from './routes/_authenticated/admin.ops'
import { Route as AuthenticatedAdminOgSnapshotsRouteImport } from './routes/_authenticated/admin.og-snapshots'
import { Route as AuthenticatedAdminNotificationsAuditRouteImport } from './routes/_authenticated/admin.notifications-audit'
import { Route as AuthenticatedAdminKycRouteImport } from './routes/_authenticated/admin.kyc'
import { Route as AuthenticatedAdminFunnelRouteImport } from './routes/_authenticated/admin.funnel'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin.emails'
import { Route as AuthenticatedAdminEmailTestRouteImport } from './routes/_authenticated/admin.email-test'
import { Route as AuthenticatedAdminEmailOpsRouteImport } from './routes/_authenticated/admin.email-ops'
import { Route as AuthenticatedAdminDisputesRouteImport } from './routes/_authenticated/admin.disputes'
import { Route as AuthenticatedJobsJobIdConfirmRouteImport } from './routes/_authenticated/jobs.$jobId.confirm'
import { Route as AuthenticatedHelperOnboardWizardRouteImport } from './routes/_authenticated/helper.onboard.wizard'
import { Route as AuthenticatedBookingsIdDisputeRouteImport } from './routes/_authenticated/bookings.$id.dispute'
import { Route as AuthenticatedAdminKycEmailsRouteImport } from './routes/_authenticated/admin.kyc.emails'
import { Route as AuthenticatedAdminKycEmailStatsRouteImport } from './routes/_authenticated/admin.kyc.email-stats'
import { Route as AuthenticatedAdminKycHelperIdRouteImport } from './routes/_authenticated/admin.kyc.$helperId'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ReferralsRoute = ReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => rootRouteImport
          })
const ProfessionalTermsRoute = ProfessionalTermsRouteImport.update({
            id: '/professional-terms',path: '/professional-terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PostJobRoute = PostJobRouteImport.update({
            id: '/post-job',path: '/post-job',getParentRoute: () => rootRouteImport
          })
const LondonRoute = LondonRouteImport.update({
            id: '/london',path: '/london',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const CancellationRoute = CancellationRouteImport.update({
            id: '/cancellation',path: '/cancellation',getParentRoute: () => rootRouteImport
          })
const BrowseRoute = BrowseRouteImport.update({
            id: '/browse',path: '/browse',getParentRoute: () => rootRouteImport
          })
const BecomeHelperRoute = BecomeHelperRouteImport.update({
            id: '/become-helper',path: '/become-helper',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })
const HelpersHelperIdRoute = HelpersHelperIdRouteImport.update({
            id: '/helpers/$helperId',path: '/helpers/$helperId',getParentRoute: () => rootRouteImport
          })
const LondonAreaRoute = LondonAreaRouteImport.update({
            id: '/$area',path: '/$area',getParentRoute: () => LondonRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthResetRoute = AuthResetRouteImport.update({
            id: '/reset',path: '/reset',getParentRoute: () => AuthRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const LondonAreaServiceRoute = LondonAreaServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => LondonAreaRoute
          })
const AuthenticatedHelperVerificationRoute = AuthenticatedHelperVerificationRouteImport.update({
            id: '/helper/verification',path: '/helper/verification',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelperOnboardRoute = AuthenticatedHelperOnboardRouteImport.update({
            id: '/helper/onboard',path: '/helper/onboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelperOffersRoute = AuthenticatedHelperOffersRouteImport.update({
            id: '/helper/offers',path: '/helper/offers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelperKycRoute = AuthenticatedHelperKycRouteImport.update({
            id: '/helper/kyc',path: '/helper/kyc',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelperAvailabilityRoute = AuthenticatedHelperAvailabilityRouteImport.update({
            id: '/helper/availability',path: '/helper/availability',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBookingsIdRoute = AuthenticatedBookingsIdRouteImport.update({
            id: '/bookings/$id',path: '/bookings/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTrustRoute = AuthenticatedAdminTrustRouteImport.update({
            id: '/admin/trust',path: '/admin/trust',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTawkRoute = AuthenticatedAdminTawkRouteImport.update({
            id: '/admin/tawk',path: '/admin/tawk',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminStripeTestsRoute = AuthenticatedAdminStripeTestsRouteImport.update({
            id: '/admin/stripe-tests',path: '/admin/stripe-tests',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminShareDebugRoute = AuthenticatedAdminShareDebugRouteImport.update({
            id: '/admin/share-debug',path: '/admin/share-debug',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSecurityRoute = AuthenticatedAdminSecurityRouteImport.update({
            id: '/admin/security',path: '/admin/security',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/admin/reviews',path: '/admin/reviews',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminQualityRoute = AuthenticatedAdminQualityRouteImport.update({
            id: '/admin/quality',path: '/admin/quality',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOpsRoute = AuthenticatedAdminOpsRouteImport.update({
            id: '/admin/ops',path: '/admin/ops',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOgSnapshotsRoute = AuthenticatedAdminOgSnapshotsRouteImport.update({
            id: '/admin/og-snapshots',path: '/admin/og-snapshots',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminNotificationsAuditRoute = AuthenticatedAdminNotificationsAuditRouteImport.update({
            id: '/admin/notifications-audit',path: '/admin/notifications-audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminKycRoute = AuthenticatedAdminKycRouteImport.update({
            id: '/admin/kyc',path: '/admin/kyc',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFunnelRoute = AuthenticatedAdminFunnelRouteImport.update({
            id: '/admin/funnel',path: '/admin/funnel',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/admin/emails',path: '/admin/emails',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailTestRoute = AuthenticatedAdminEmailTestRouteImport.update({
            id: '/admin/email-test',path: '/admin/email-test',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailOpsRoute = AuthenticatedAdminEmailOpsRouteImport.update({
            id: '/admin/email-ops',path: '/admin/email-ops',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminDisputesRoute = AuthenticatedAdminDisputesRouteImport.update({
            id: '/admin/disputes',path: '/admin/disputes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedJobsJobIdConfirmRoute = AuthenticatedJobsJobIdConfirmRouteImport.update({
            id: '/jobs/$jobId/confirm',path: '/jobs/$jobId/confirm',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelperOnboardWizardRoute = AuthenticatedHelperOnboardWizardRouteImport.update({
            id: '/wizard',path: '/wizard',getParentRoute: () => AuthenticatedHelperOnboardRoute
          })
const AuthenticatedBookingsIdDisputeRoute = AuthenticatedBookingsIdDisputeRouteImport.update({
            id: '/dispute',path: '/dispute',getParentRoute: () => AuthenticatedBookingsIdRoute
          })
const AuthenticatedAdminKycEmailsRoute = AuthenticatedAdminKycEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminKycRoute
          })
const AuthenticatedAdminKycEmailStatsRoute = AuthenticatedAdminKycEmailStatsRouteImport.update({
            id: '/email-stats',path: '/email-stats',getParentRoute: () => AuthenticatedAdminKycRoute
          })
const AuthenticatedAdminKycHelperIdRoute = AuthenticatedAdminKycHelperIdRouteImport.update({
            id: '/$helperId',path: '/$helperId',getParentRoute: () => AuthenticatedAdminKycRoute
          })





const AuthenticatedAdminKycRouteChildren = {
  AuthenticatedAdminKycHelperIdRoute: AuthenticatedAdminKycHelperIdRoute,AuthenticatedAdminKycEmailStatsRoute: AuthenticatedAdminKycEmailStatsRoute,AuthenticatedAdminKycEmailsRoute: AuthenticatedAdminKycEmailsRoute
}

const AuthenticatedAdminKycRouteWithChildren = AuthenticatedAdminKycRoute._addFileChildren(AuthenticatedAdminKycRouteChildren)




const AuthenticatedBookingsIdRouteChildren = {
  AuthenticatedBookingsIdDisputeRoute: AuthenticatedBookingsIdDisputeRoute
}

const AuthenticatedBookingsIdRouteWithChildren = AuthenticatedBookingsIdRoute._addFileChildren(AuthenticatedBookingsIdRouteChildren)




const AuthenticatedHelperOnboardRouteChildren = {
  AuthenticatedHelperOnboardWizardRoute: AuthenticatedHelperOnboardWizardRoute
}

const AuthenticatedHelperOnboardRouteWithChildren = AuthenticatedHelperOnboardRoute._addFileChildren(AuthenticatedHelperOnboardRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedAdminDisputesRoute: AuthenticatedAdminDisputesRoute,AuthenticatedAdminEmailOpsRoute: AuthenticatedAdminEmailOpsRoute,AuthenticatedAdminEmailTestRoute: AuthenticatedAdminEmailTestRoute,AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute,AuthenticatedAdminFunnelRoute: AuthenticatedAdminFunnelRoute,AuthenticatedAdminKycRoute: AuthenticatedAdminKycRouteWithChildren,AuthenticatedAdminNotificationsAuditRoute: AuthenticatedAdminNotificationsAuditRoute,AuthenticatedAdminOgSnapshotsRoute: AuthenticatedAdminOgSnapshotsRoute,AuthenticatedAdminOpsRoute: AuthenticatedAdminOpsRoute,AuthenticatedAdminQualityRoute: AuthenticatedAdminQualityRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminSecurityRoute: AuthenticatedAdminSecurityRoute,AuthenticatedAdminShareDebugRoute: AuthenticatedAdminShareDebugRoute,AuthenticatedAdminStripeTestsRoute: AuthenticatedAdminStripeTestsRoute,AuthenticatedAdminTawkRoute: AuthenticatedAdminTawkRoute,AuthenticatedAdminTrustRoute: AuthenticatedAdminTrustRoute,AuthenticatedBookingsIdRoute: AuthenticatedBookingsIdRouteWithChildren,AuthenticatedHelperAvailabilityRoute: AuthenticatedHelperAvailabilityRoute,AuthenticatedHelperKycRoute: AuthenticatedHelperKycRoute,AuthenticatedHelperOffersRoute: AuthenticatedHelperOffersRoute,AuthenticatedHelperOnboardRoute: AuthenticatedHelperOnboardRouteWithChildren,AuthenticatedHelperVerificationRoute: AuthenticatedHelperVerificationRoute,AuthenticatedJobsJobIdConfirmRoute: AuthenticatedJobsJobIdConfirmRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AuthRouteChildren = {
  AuthResetRoute: AuthResetRoute,AuthResetPasswordRoute: AuthResetPasswordRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const LondonAreaRouteChildren = {
  LondonAreaServiceRoute: LondonAreaServiceRoute
}

const LondonAreaRouteWithChildren = LondonAreaRoute._addFileChildren(LondonAreaRouteChildren)



const LondonRouteChildren = {
  LondonAreaRoute: LondonAreaRouteWithChildren
}

const LondonRouteWithChildren = LondonRoute._addFileChildren(LondonRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRouteWithChildren,BecomeHelperRoute: BecomeHelperRoute,BrowseRoute: BrowseRoute,CancellationRoute: CancellationRoute,CategoriesRoute: CategoriesRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,HowItWorksRoute: HowItWorksRoute,LondonRoute: LondonRouteWithChildren,PostJobRoute: PostJobRoute,PrivacyRoute: PrivacyRoute,ProfessionalTermsRoute: ProfessionalTermsRoute,ReferralsRoute: ReferralsRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,HelpersHelperIdRoute: HelpersHelperIdRoute,ServicesSlugRoute: ServicesSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)